import * as states from './states'
import * as mutations from './mutations'
import * as actions from './actions'

export default {
  states,
  mutations,
  actions
}
